// The site's navigation, in one place so the header, phone menu and footer can't drift apart.

export type SiteLink = { label: string; href: string; newTab?: boolean };

export const MENU_SERVICES: SiteLink[] = [
  { label: "Web Design", href: "/web-design.html" },
  { label: "Design", href: "/design.html" },
  { label: "Social Media", href: "/social-media.html" },
  { label: "Local SEO", href: "/local-seo.html" },
  { label: "Care Plans", href: "/care-plans.html" },
  { label: "Custom Builds", href: "/custom-builds.html" },
  { label: "Contractors", href: "/contractor-websites.html" },
  { label: "Restaurants", href: "/restaurant-websites.html" },
];

export const NAV_LINKS: SiteLink[] = [
  { label: "Our Work", href: "/our-work.html" },
  { label: "Prices", href: "/website-cost.html" },
  { label: "Order Online", href: "/cart.html" },
  { label: "Customer Portal", href: "/portal.html" },
];

export const FOOTER_GROUPS: { title: string; links: SiteLink[] }[] = [
  { title: "Services", links: MENU_SERVICES.slice(0, 6) },
  {
    title: "Who We Build For",
    links: [
      { label: "Contractors", href: "/contractor-websites.html" },
      { label: "Restaurants", href: "/restaurant-websites.html" },
      { label: "Hattiesburg", href: "/web-design-hattiesburg-ms.html" },
      { label: "Purvis", href: "/web-design-purvis-ms.html" },
      { label: "Petal", href: "/web-design-petal-ms.html" },
      { label: "McComb", href: "/web-design-mccomb-ms.html" },
    ],
  },
  {
    title: "Customers",
    links: [
      { label: "Customer Portal", href: "/portal.html" },
      { label: "Order Online", href: "/cart.html" },
      { label: "Prices", href: "/website-cost.html" },
      { label: "Free Website Preview", href: "https://leads.rare-works.com/" },
      { label: "Skeulur", href: "https://skeulur.rare-works.com", newTab: true },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Our Work", href: "/our-work.html" },
      { label: "Our Team", href: "/team.html" },
      { label: "Careers", href: "/careers.html" },
      { label: "Contact", href: "/contact.html" },
      { label: "Facebook", href: "https://www.facebook.com/RareWorksStudio", newTab: true },
      { label: "Google", href: "https://share.google/fImwHHIfmI1fjQeu0", newTab: true },
      { label: "Terms", href: "/terms.html" },
      { label: "Privacy", href: "/privacy.html" },
    ],
  },
  {
    title: "Questions",
    links: [
      { label: "Website or Facebook?", href: "/website-vs-facebook.html" },
      { label: "Getting on Google Maps", href: "/google-maps-listing.html" },
      { label: "Who owns my website?", href: "/who-owns-my-website.html" },
    ],
  },
];
